<template>
  <div class="enhance-tag">
    <template v-for="item in shorexTags">
      <img class="enhance-tag-item" 
      :style="{marginBottom: marginBottom+'px'}"  :src="item.imageUe" v-if="item.imageUe" alt="" :key="item.id"/>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    shorexTags: {
      type: Array,
      default() {
        return []
      }
    },
    marginBottom: {
      type: [String, Number],
      default: '4'
    }
  },

  
  
}
</script>

<style lang="less" scoped>
.enhance-tag{
  display: flex;
  flex-wrap: wrap;
}

.enhance-tag-item:last-child {
  margin-right: 0;
}

.enhance-tag-item{
  height: 28px;
  display: block;
  margin-right: 10px;
}

</style>